import { useEffect, useRef } from 'react'

/** Indicates if it is the first render of a component */
export const useIsFirstRender = (): boolean => {
    const isFirstRender = useRef<boolean>(true)
    useEffect(() => {
        isFirstRender.current = false
    }, [])
    return isFirstRender.current
}
